import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { openMsg, loadingModal } from 'redux-app';

import {
   Button,
   Container,
   Grid,
   Paper,
   TextField,
   Typography
} from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { fechas, transformacion, validacion } from 'lib.common';
import { ChipsDatosAdicionales, DialogDs, SelectDs, SelectPlus, hooks, toast } from 'lib.front';
import {
   getActividades,
   getData,
   getDisponibilidad,
   getEnviarEmail,
   getProducto,
   programarAtencion,
   verificarHorarioQuery
} from './queries';
import SendIcon from '@material-ui/icons/Send';

//ESQUEMAS
import { esquemaCampos, esquemaValidacion, oEstadosActividad } from './esquemas';

//GRAPHQL
import { useLazyQuery, useMutation, useQuery } from '@apollo/react-hooks';
import { KeyboardDatePicker, KeyboardTimePicker } from '@material-ui/pickers';
import clsx from 'clsx';

const { useValidacion } = hooks;

const useStyles = makeStyles(theme => ({
   container: {
      marginTop: theme.spacing(2)
   },
   textField: {
      width: '100%'
   },
   marginAuxT: {
      marginTop: theme.spacing(1)
   },
   marginHorario: {
      margin: '10px'
   },
   alignContent:{
      alignContent:'center',
   },
   borde: {
      border: `1px solid #bcbdbf`,
      borderRadius: theme.shape.borderRadius
   },
   dividerRoot: {
      height: 1,
      margin: 0, // Reset browser default style.
      border: 'none',
      flexShrink: 0,
      backgroundColor: '#bcbdbf'
   },
   overlay: {
      paddingTop: theme.spacing(0.5),
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5),
      borderTopLeftRadius: theme.shape.borderRadius,
      borderTopRightRadius: theme.shape.borderRadius
   }
}));

// const codAtencion = ['ACT', 'SOP', 'CAP', 'INS'];
const codAtencion = ['SOP'];
const datosAdicionales = ['Teléfono', 'E-Mail', 'Cargo'];

function ProgramarAtencion({ usuario, openMsgModal, openWaitModal }) {
   const classes = useStyles();
   const [dataTs, setDataTs] = useState([]);
   const [tiposSoporte, setTiposSoporte] = useState([]);
   const [dataTat, setDataTat] = useState([]);
   const [dataProdTodos, setDataProdTodos] = useState([]);
   const [dataAsesor, setDataAsesor] = useState([]);
   const [listaContacto, setListaContacto] = useState([]);
   const [actividades, setActividades] = useState([]);
   const [actividadesEstados, setActividadesEstados] = useState({});
   const [dataAsesorLibre, setDataAsesorLibre] = useState([]);
   const [asesorResponsable, setAsesorResponsable] = useState('');
   const [enviarEmail, setEnviarEmail] = useState('');
   const [disabled, setDisabled] = useState(false);
   const [verTodosProductos, setVerTodosProductos] = useState(false);
   const [mostrarActividades, setMostrarActividades] = useState(false);
   const [actividad, setActividad] = useState(-1);
   const [showMensaje, setShowMensaje] = useState(false);
   const [codigoEmail, setCodigoEmail] = useState('');
   const [productosCliente, setProductosCliente] = useState([])

   const contactoCampoObligatorio = 'nombre';

   const { loading: loadingD, error: errorD, data: dataD } = useQuery(getData);
   const { campos, existeError, handleOnChange, validacionManual, setCampo } = useValidacion(
      esquemaCampos,
      esquemaValidacion
   );

   const [
      recuperarProd,
      { loading: loadingProd, called: calledProd, error: errorProd, data: dataProd }
   ] = useLazyQuery(getProducto);

   const [
      recuperarTac,
      { loading: loadingTac, called: calledTac, error: errorTac, data: dataTac }
   ] = useLazyQuery(getActividades);

   const [recuperarAL, { loading: loadingAL, error: errorAL, data: dataAL }] = useLazyQuery(
      getDisponibilidad
   );

   const [
      insertar,
      { loading: loadingIn, called: calledIn, error: errorIn, data: dataIn }
   ] = useMutation(programarAtencion);

   const [
      enviarEmailEE,
      { loading: loadingEE, called: calledEE, error: errorEE, data: dataEE }
   ] = useLazyQuery(getEnviarEmail);

   const [
      verificarHorario,
      { loading: loadingVH, called: calledVH, error: errorVH, data: dataVH }
   ] = useLazyQuery(verificarHorarioQuery);

   useEffect(() => {
      openWaitModal(loadingD || loadingTac || loadingProd || loadingIn || loadingEE || loadingAL || loadingVH);
   }, [loadingD, loadingTac, loadingProd, loadingIn, loadingAL]);

   useEffect(() => {
      let eMsg = '';
      if (!validacion.esVarNullUndef(errorTac)) {
         eMsg = eMsg + JSON.stringify(errorTac);
      } else if (!validacion.esVarNullUndef(errorD)) {
         eMsg = eMsg + JSON.stringify(errorD);
      }
      if (!validacion.esVarNullUndef(errorProd)) {
         eMsg = eMsg + JSON.stringify(errorProd);
      }
      if (!validacion.esVarNullUndef(errorIn)) {
         eMsg = eMsg + JSON.stringify(errorIn);
      }
      if (!validacion.esVarNullUndef(errorEE)) {
         eMsg = eMsg + JSON.stringify(errorEE);
      }
      if (!validacion.esVarNullUndef(errorAL)) {
         eMsg = eMsg + JSON.stringify(errorAL);
      }
      if (!validacion.esVarNullUndef(errorVH)) {
         eMsg = eMsg + JSON.stringify(errorVH);
      }
      if (eMsg !== '') {
         openMsgModal(eMsg);
      }
   }, [errorTac, errorD, errorProd, errorIn, errorEE, errorAL, errorVH]);

   useEffect(() => {
      if (campos.cliente?.valor !== null && campos.cliente?.valor !== '') {
         recuperarProd({
            variables: {
               codigoCliente: campos.cliente?.valor
            }
         });
      }
   }, [campos.cliente?.valor]);

   useEffect(() => {
      if (calledProd && dataProd !== undefined) {
         const hoy = new Date();
         hoy.setHours(0, 0, 0, 0);
         const dataAux = dataProd['clienteProductosFiltro'].filter(item => {
            const fechaVigencia = new Date(item.fechaHora);
            fechaVigencia.setHours(0, 0, 0, 0);
            return fechaVigencia > hoy && item.producto.activo
         });
         if (dataAux !== undefined && dataAux !== null && dataAux.length > 0) {
            setCampo('producto', dataAux[0].producto.codigo);
            setProductosCliente(dataAux);
            setVerTodosProductos(false);
         } else {
            if (dataProdTodos.length > 0) {
               setCampo('producto', dataProdTodos[0].codigo);
            }
            setVerTodosProductos(true);
         }
      }
   }, [dataProd]);

   useEffect(() => {
      if (
         campos.producto?.valor !== undefined &&
         campos.producto?.valor !== null &&
         campos.producto?.valor !== ''
      ) {
         if (campos.producto?.valor === '+') {
            setCampo('producto', dataProdTodos[0].codigo);
            setVerTodosProductos(true);
         } else if (campos.producto?.valor === '-') {
            if (productosCliente[0]) {
               setCampo('producto', productosCliente[0].producto.codigo);
            } else {
               //Ejecutar asignar version
            }
            setVerTodosProductos(false);
         } else {
            if (!verTodosProductos) {
               let prodSeleccionado = productosCliente.find(
                  producto => producto.producto.codigo == campos.producto.valor
               );
               let fechaVigencia = new Date(prodSeleccionado.fechaHora);
               if (fechaVigencia >= new Date()) {
                  setDataTs([tiposSoporte[1]]);
               } else {
                  setDataTs([tiposSoporte[0]]);
               }
            } else {
               setDataTs(tiposSoporte);
            }
         }
      }
   }, [campos.producto?.valor]);

   useEffect(() => {
      if (usuario) {
         if (usuario.contacto && usuario.contacto !== '') {
            let contacto = { nombre: usuario.contacto };
            if (usuario.telefono && usuario.telefono !== '') {
               contacto.telefono = usuario.telefono;
            }
            if (usuario.email && usuario.email !== '') {
               contacto['E-Mail'] = usuario.email;
            }
            setListaContacto([contacto]);
         }
         setCampo('cliente', usuario.codigo);
         setAsesorResponsable(usuario.asesorResponsable);
         setEnviarEmail([usuario.email]);
      }
   }, [usuario]);

   useEffect(() => {
      if (dataD !== undefined && dataD !== null) {
         let msgWarning = '';
         let dataAux = dataD['asesores'];
         if (dataAux !== null) {
            setDataAsesor(dataAux);
            if (dataAux.length === 0) {
               msgWarning += '- Asesores.\n';
            }
         }
         dataAux = dataD['tipoAtenciones'].filter(atencion =>
            codAtencion.includes(atencion.codigo)
         );
         if (dataAux !== null) {
            setDataTat(dataAux);
            if (dataAux.length === 0) {
               msgWarning += '- Tipo de atenciones.\n';
            }
         }
         dataAux = dataD['tipoServicios'];
         if (dataAux !== null) {
            dataAux.pop();
            setDataTs(dataAux);
            setTiposSoporte(dataAux);
            if (dataAux.length === 0) {
               msgWarning += '- Tipos de servicios.\n';
            }
         }
         dataAux = dataD['productos'];
         if (dataAux !== null) {
            setDataProdTodos(dataAux);
         }
         if (msgWarning !== '') {
            setDisabled(true);
            msgWarning =
               'No existe la siguiente infomación en el sistema para poder continuar:\n' +
               msgWarning;
            openMsgModal(msgWarning);
         }
      }
   }, [dataD]);

   useEffect(() => {
      if (calledTac && dataTac !== undefined && mostrarActividades) {
         const dataAux = dataTac['tipoActividadesFiltro'];
         if (dataAux !== undefined && dataAux !== null && dataAux.length > 0) {
            setActividades(dataAux);
            const hoy = new Date();
            hoy.setMinutes(Math.floor(hoy.getMinutes() / 30) * 30 + 30, 0, 0);
            const fin = new Date(hoy);
            fin.setMinutes(fin.getMinutes() + 30);
            const dataActi = dataAux.map((item, index) => {
               return new oEstadosActividad(
                  item.codigo,
                  item.denominacion,
                  null,
                  hoy,
                  hoy,
                  fin,
                  null,
                  '',
                  ''
               );
            });
            setActividadesEstados({ ...dataActi });
            setActividad(0);
         } else {
            openMsgModal(
               'No existe la siguiente infomación en el sistema para poder continuar:\n- Actividades del tipo de atención.'
            );
         }
      }
   }, [dataTac, mostrarActividades]);

   useEffect(() => {
      const dataAux = dataAL?.ConsultaAsesorLibre || null;
      if (dataAux !== null) {
         setDataAsesorLibre(dataAux);
         if (dataAux.length > 0) {
            let datosAsesor = dataAux.find(asesor => asesor.codigo == asesorResponsable);
            let asesorR = datosAsesor ? datosAsesor : dataAux[0];
            let datosAsesorR = {
               value: asesorR.codigo,
               label: `${asesorR.nombre} ${asesorR.apPaterno} ${asesorR.especialidad ? '(' + asesorR.especialidad + ')' : ''
                  }`,
               dataItem: asesorR
            };
            handleChange(datosAsesorR, 'responsable');
         } else {
            handleChange(null, 'responsable');
         }
      }
   }, [dataAL]);

   useEffect(() => {
      if (calledEE && dataEE !== undefined && dataEE !== null) {
         let dataAux = dataEE['enviarMailProgramarAtencion'];
         if (dataAux !== null) {
            setShowMensaje(true);
         }
      }
   }, [dataEE]);

   useEffect(() => {
      if (calledVH && dataVH !== undefined && dataVH.cruceHorarioAtencioDetalle) {
         const cruces = dataVH.cruceHorarioAtencioDetalle;
         if (cruces.length !== 0) {
            const inicio = formatearHora(cruces[0].fechaHoraInicio);
            const fin = formatearHora(cruces[0].fechaHoraFinal);
            toast.showError(`Usted ya tiene programa una atención en el horario de ${inicio}`)
         } else {
            procesarGrabar();
         }
      }
   }, [dataVH]);

   useEffect(() => {
      if (campos.tipoAtencion?.valor && campos.tipoAtencion?.valor !== '') {
         recuperarTac({
            variables: {
               codigoAtencion: campos.tipoAtencion?.valor
            }
         });
         let tipoAtencionActual = dataTat.find(aten => aten.codigo == campos.tipoAtencion?.valor);
         setCampo('descripcion', tipoAtencionActual.denominacion + ' de ');
      } else {
         setActividad(-1);
      }
   }, [campos.tipoAtencion?.valor]);

   useEffect(() => {
      if (
         Boolean(actividadesEstados[actividad]?.fecha || null) &&
         Boolean(actividadesEstados[actividad]?.horaIni || null)
      ) {
         const Fecha = new Date(actividadesEstados[actividad].fecha);
         const HoraIni = new Date(actividadesEstados[actividad].horaIni);
         const diaFecha = Fecha.getDay();
         const nuevoDate = new Date(
            Fecha.getFullYear(),
            Fecha.getMonth(),
            Fecha.getDate(),
            HoraIni.getHours(),
            HoraIni.getMinutes(),
            HoraIni.getSeconds()
         );
         recuperarAL({ variables: { fecha: nuevoDate, dia: diaFecha } });
      }
   }, [actividadesEstados[actividad]?.fecha, actividadesEstados[actividad]?.horaIni]);

   useEffect(() => {
      if (dataTat && dataTat.length > 0) {
         setCampo('tipoAtencion', dataTat[0].codigo);
      }
   }, [dataTat]);

   useEffect(() => {
      if (dataTs && dataTs.length > 0) {
         setCampo('tipoServicio', dataTs[0].codigo);
      }
   }, [dataTs]);

   useEffect(() => {
      if (calledIn && dataIn !== undefined && dataIn !== null) {
         let dataAux = dataIn['programarAtencion'];
         if (dataAux !== null) {
            procesarEnviarEmail();
         }
      }
   }, [dataIn]);

   useEffect(() => {
      if (actividadesEstados[actividad]?.responsable) {
         setCampo('responsable', actividadesEstados[actividad]?.responsable.value);
         setCampo('sucursal', actividadesEstados[actividad]?.responsable.dataItem.sucursal.codigo);
      }
   }, [actividadesEstados[actividad]?.responsable]);

   const handleClose = () => {
      inicializar();
      setMostrarActividades(false);
      setShowMensaje(false);
   };

   function estaHoraEnRango(hora, minutos, horaInicio, minutoInicio, horaFin, minutoFin) {
      const tiempoInicio = horaInicio * 60 + minutoInicio; // Hora de inicio en minutos
      const tiempoFin = horaFin * 60 + minutoFin; // Hora de fin en minutos
      const tiempoActual = hora * 60 + minutos; // Hora actual en minutos

      return tiempoActual >= tiempoInicio && tiempoActual <= tiempoFin;
   }

   function estaDentroDelHorario(dia, fecha) {
      const diaSemana = dia.getDay(); // Día de la semana
      const hora = fecha.getHours(); // Hora de la fecha
      const minutos = fecha.getMinutes(); // Minutos de la fecha

      // Lunes a Viernes (1-5): de 9:00 AM a 1:00 PM y de 3:00 PM a 7:00 PM
      if (diaSemana >= 1 && diaSemana <= 5) {
         if (
            estaHoraEnRango(hora, minutos, 9, 0, 13, 0) || // 9:00 AM - 1:00 PM
            estaHoraEnRango(hora, minutos, 15, 0, 19, 0) // 3:00 PM - 7:00 PM
         ) {
            return true;
         }
      }

      // Sábado (6): de 9:00 AM a 1:00 PM
      if (diaSemana === 6) {
         if (estaHoraEnRango(hora, minutos, 9, 0, 13, 0)) {
            // 9:00 AM - 1:00 PM
            return true;
         }
      }

      // Si no está en los horarios de atención
      return false;
   }

   function toggleMostrarActividades() {
      setMostrarActividades(!mostrarActividades);
   }

   function handleChange(elegido, campo) {
      setActividadesEstados(prev => ({
         ...prev,
         [actividad]: {
            ...prev[actividad],
            [campo]: elegido
         }
      }));
   }

   function handleChangeHoraAtencion(elegido) {
      handleChange(elegido, 'horaIni');
      const horaFin = new Date(elegido);
      horaFin.setMinutes(horaFin.getMinutes() + 30);
      handleChange(horaFin, 'horaFin');
   }

   async function validarTodos() {
      let ok =
         (await validacionManual('cliente', campos.cliente.valor)) === '' &&
         (await validacionManual('descripcion', campos.descripcion.valor)) === '' &&
         (await validacionManual('producto', campos.producto.valor)) === '' &&
         (await validacionManual('responsable', campos.responsable.valor)) === '' &&
         actividadesEstados[actividad].horaFin > actividadesEstados[actividad].horaIni &&
         estaDentroDelHorario(
            actividadesEstados[actividad].fecha,
            actividadesEstados[actividad].horaIni
         ) &&
         estaDentroDelHorario(
            actividadesEstados[actividad].fecha,
            actividadesEstados[actividad].horaFin
         );

      return ok;
   }

   async function generarDetalles(codigoAtencion, _actividadesEstados) {
      let arregloDetalles = [];
      let arregloEjecutados = [];
      await Promise.all(
         Object.keys(_actividadesEstados).map(async item => {
            const fechaHoraInicio = await fechas.concatDateTime(
               _actividadesEstados[item].fecha,
               _actividadesEstados[item].horaIni
            );
            const fechaHoraFinal = await fechas.concatDateTime(
               _actividadesEstados[item].fecha,
               _actividadesEstados[item].horaFin
            );

            if (Array.isArray(_actividadesEstados[item].responsable)) {
               await Promise.all(
                  _actividadesEstados[item].responsable.map(actResponsable => {
                     arregloDetalles.push({
                        atencion: codigoAtencion,
                        actividad: _actividadesEstados[item].actividad.toString(),
                        modulo: campos.modulo.valor != '' ? campos.modulo.valor : null,
                        descripcion: _actividadesEstados[item].descripcion,
                        observaciones: _actividadesEstados[item].observaciones,
                        responsable: actResponsable ? actResponsable.value : usuario.codigo,
                        fechaHoraInicio,
                        fechaHoraFinal
                     });
                     arregloEjecutados.push({
                        atencion: codigoAtencion,
                        actividad: _actividadesEstados[item].actividad.toString(),
                        modulo: campos.modulo.valor != '' ? campos.modulo.valor : null,
                        denominacion: _actividadesEstados[item].denominacion,
                        descripcion: _actividadesEstados[item].descripcion,
                        responsable: actResponsable ? actResponsable.value : usuario.codigo,
                        sucursal: campos.sucursal.valor || null,
                        fechaHoraInicio,
                        fechaHoraFinal,
                        asesorQDeriva: _actividadesEstados[item].asesorQDeriva || usuario.codigo
                     });
                     return '';
                  })
               );
            } else {
               arregloDetalles.push({
                  atencion: codigoAtencion,
                  actividad: _actividadesEstados[item].actividad.toString(),
                  descripcion: _actividadesEstados[item].descripcion,
                  observaciones: _actividadesEstados[item].observaciones,
                  responsable: _actividadesEstados[item].responsable
                     ? _actividadesEstados[item].responsable.value
                     : usuario.codigo,
                  fechaHoraInicio,
                  fechaHoraFinal
               });
               arregloEjecutados.push({
                  atencion: codigoAtencion,
                  actividad: _actividadesEstados[item].actividad.toString(),
                  denominacion: _actividadesEstados[item].denominacion,
                  descripcion: _actividadesEstados[item].descripcion,
                  responsable: _actividadesEstados[item].responsable
                     ? _actividadesEstados[item].responsable.value
                     : usuario.codigo,
                  sucursal: campos.sucursal.valor || null,
                  fechaHoraInicio,
                  fechaHoraFinal
               });
            }
            return '';
         })
      );
      return [arregloDetalles, arregloEjecutados];
   }

   function inicializar() {
      setCampo('descripcion', esquemaCampos.descripcion.valor);
      setCampo('producto', esquemaCampos.producto.valor);
      setListaContacto([]);
      if (dataAsesor.length > 0) {
         setCampo('responsable', dataAsesor[0].codigo);
      } else {
         setCampo('responsable', esquemaCampos.responsable.valor);
      }
      if (dataTs.length > 0) {
         setCampo('tipoServicio', dataTs[0].codigo);
      } else {
         setCampo('tipoServicio', esquemaCampos.tipoServicio.valor);
      }
      if (dataTat.length > 0) {
         setCampo('tipoAtencion', dataTat[0].codigo);
      } else {
         setCampo('tipoAtencion', esquemaCampos.tipoAtencion.valor);
      }
      setCampo('fechaLimite', esquemaCampos.fechaLimite.valor);
      setCampo('prioridad', 0);

      setActividad(0);
      setActividadesEstados({});
   }

   async function procesarEnviarEmail() {
      const fechaHoraInicio = await fechas.concatDateTime(
         actividadesEstados[0].fecha,
         actividadesEstados[0].horaIni
      );
      const fechaHoraFin = await fechas.concatDateTime(
         actividadesEstados[0].fecha,
         actividadesEstados[0].horaFin
      );
      let asesorAsignado = campos.responsable.valor.label;
      for (const key in actividadesEstados) {
         if (Object.hasOwnProperty.call(actividadesEstados, key)) {
            const actividadActual = actividadesEstados[key];
            if (actividadActual.responsable) {
               asesorAsignado = actividadActual.responsable.label;
               break;
            }
         }
      }
      let emailContacto = listaContacto.reduce((acc, contacto) => {
         if (contacto['E-Mail'] !== undefined) {
            acc.push(contacto['E-Mail']);
         }
         return acc;
      }, []);
      let emails = new Set([...enviarEmail, ...emailContacto]);
      const parametros = {
         email: [...emails],
         razonSocial:
            usuario.tipoDoc === '6'
               ? usuario.razonSocial
               : `${usuario.nombre} ${usuario.apPaterno}`,
         asesor: asesorAsignado,
         codigoAtencion: codigoEmail,
         ruc: usuario.nroDoc,
         fechaHoraInicio: fechaHoraInicio,
         fechaHoraFin: fechaHoraFin
      };
      return enviarEmailEE({ variables: parametros });
   }

   const construirFecha = (fecha, hora) => {
      const date = new Date(fecha);
      date.setHours(hora.getHours(), hora.getMinutes(), hora.getSeconds());
      return date;
   };

   const formatearHora = (fecha) => {
      return new Date(fecha).toLocaleTimeString('es-PE', {
         hour: '2-digit',
         minute: '2-digit',
         timeZone: 'America/Lima'
      });
   };

   const verificarCruceHorario = async () => {
      const ok = await validarTodos();
      if (ok) {
         const actividad = actividadesEstados?.[0];
         const fechaIni = construirFecha(actividad.fecha, actividad.horaIni);
         const fechaFin = construirFecha(actividad.fecha, actividad.horaFin);
         verificarHorario({
            variables: {
               codCliente: campos.cliente.valor,
               fechaHoraInicio: fechaIni,
               fechaHoraFinal: fechaFin
            }
         })
      } else {
         toast.showError('Se han encontrado errores al validar los datos.');
      }
   };

   const procesarGrabar = async () => {
      let listaContactoString = '[]';
      listaContactoString = JSON.stringify(listaContacto);
      const codigoAtencion = await transformacion.generarUuid(15);
      setCodigoEmail(codigoAtencion);
      const atencion = {
         codigo: codigoAtencion,
         cliente: campos.cliente.valor,
         sucursal: campos.sucursal.valor || null,
         producto: campos.producto.valor,
         modulo: campos.modulo.valor != '' ? campos.modulo.valor : null,
         descripcion: campos.descripcion.valor,
         tipoServicio: campos.tipoServicio.valor,
         responsable: campos.responsable.valor,
         tipoAtencion: campos.tipoAtencion.valor,
         contacto: listaContactoString,
         fechaLimite: campos.fechaLimite.valor,
         estado: mostrarActividades ? 1 : 0,
         prioridad: campos.prioridad.valor
      };
      let [atencionDetalle, atencionEjecutada] = await generarDetalles(
         codigoAtencion,
         actividadesEstados
      );
      insertar({
         variables: {
            atencion,
            atencionDetalle,
            atencionEjecutada
         }
      });

   };


   return (
      <Container style={{ maxWidth: '95%', margin: '24px' }} >
         <Paper elevation={0} square>
            <Grid container spacing={3} style={{ padding: '16px' }}>
               <Grid item xs={12}>
                  <Typography variant="h4" gutterBottom>
                     PROGRAMAR SOPORTE
                  </Typography>
               </Grid>
               <Grid container item xs={12} spacing={1}>
                  <Grid item xs={12} sm={8} md={6} lg={4}>
                     <SelectDs
                        name="producto"
                        label="Producto"
                        variant="outlined"
                        value={campos.producto?.valor}
                        onChange={handleOnChange}
                        className={clsx(classes.textField)}
                        margin="dense"
                        error={campos.producto?.error !== ''}
                        helperText={campos.producto?.error}
                        data={productosCliente}
                        genItemValue={item => item.producto.codigo}
                        genItemKey={item => item.producto.codigo}
                        genItemLabel={item => item.producto.denominacion}
                        noDataLabel="No cuenta con productos vigentes."
                     />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3} lg={2}>
                     <SelectDs
                        id="select-tipoAtencion"
                        name="tipoAtencion"
                        label="Tipo de Atención"
                        variant="outlined"
                        value={campos.tipoAtencion?.valor}
                        onChange={handleOnChange}
                        className={clsx(classes.textField)}
                        margin="dense"
                        data={dataTat}
                        genItemValue={item => item.codigo}
                        genItemKey={item => item.codigo}
                        genItemLabel={item => item.denominacion}
                        error={campos.tipoAtencion?.error !== ''}
                        helperText={campos.tipoAtencion?.error}
                     />
                  </Grid>
                  <Grid item xs={12} sm={8} md={6}>
                     <TextField
                        label="Descripción de la Atención"
                        name="descripcion"
                        variant="outlined"
                        margin="dense"
                        className={clsx(classes.textField)}
                        required
                        onChange={handleOnChange}
                        value={campos.descripcion?.valor}
                        error={campos.descripcion?.error !== ''}
                        helperText={campos.descripcion?.error}
                     />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3} lg={2}>
                     <SelectDs
                        id="select-tipoServicio"
                        name="tipoServicio"
                        label="Tipo Servicio"
                        variant="outlined"
                        value={campos.tipoServicio?.valor}
                        onChange={handleOnChange}
                        className={clsx(classes.textField)}
                        margin="dense"
                        data={dataTs}
                        genItemValue={item => item.codigo}
                        genItemKey={item => item.codigo}
                        genItemLabel={item => item.denominacion}
                        error={campos.tipoServicio?.error !== ''}
                        helperText={campos.tipoServicio?.error}
                     />
                  </Grid>

                  <Grid item xs={12} sm={8} md={9} lg={7}>
                     <ChipsDatosAdicionales
                        label="Contacto"
                        variant="outlined"
                        fullWidth
                        datosAdicionales={listaContacto}
                        handleOnChangeDatosAdicionales={setListaContacto}
                        campoObligatorio={{
                           name: contactoCampoObligatorio,
                           label: 'Nombre Contacto'
                        }}
                        tituloModal="Agregar Información de Contacto"
                        infoSugerida={datosAdicionales}
                        columnasDatosAdicionales={['Dato', 'Valor']}
                        datosAdicionalesAgregarProps={{
                           errorValidacion: error => toast.showError(error)
                        }}
                     />
                  </Grid>
                  <Grid container item xs={12} sm={4} md={3} lg={3} alignContent='center' justify='center'>
                     <Button onClick={toggleMostrarActividades} variant="contained" color="primary" disabled={productosCliente.length == 0 || campos.producto?.valor == ''}>
                        Seleccionar horario
                     </Button>
                  </Grid>
               </Grid>
               {mostrarActividades && actividad >= 0 && (
                  <Grid
                     container
                     item
                     xs={12}
                     className={clsx(classes.borde, classes.marginHorario)}
                     spacing={1}
                     justify='center'
                  >
                     <Grid item xs={12} sm={8} md={5} lg={4} className={clsx(classes.borde, classes.alignContent)} style={{ padding: '8px' }}>
                        <Typography variant="body2" gutterBottom>
                           Horarios de Atención:
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                           Lunes a Viernes: 9:00 AM a 1:00 PM y 3:00 PM a 7:00 PM
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                           Sábados: 9:00 AM a 1:00 PM
                        </Typography>
                     </Grid>
                     {/* <Grid item xs={12} sm={3} className={classes.borde}>
                        <List>
                           <Divider classes={{ root: classes.dividerRoot }} />
                           {actividades.map((item, index) => (
                              <div key={item.codigo}>
                                 <ListItem
                                    button
                                    name={index}
                                    onClick={event => setActividad(index)}
                                    selected={actividad === index}
                                 >
                                    <ListItemText primary={item.denominacion} />
                                 </ListItem>
                                 <Divider classes={{ root: classes.dividerRoot }} />
                              </div>
                           ))}
                        </List>
                     </Grid> */}
                     <Grid container item sm={12} md={7} lg={8} spacing={1}>
                        <Grid item xs={12} sm={6} lg={3} className={classes.alignContent}>
                           <KeyboardDatePicker
                              name="fecha"
                              margin="normal"
                              label="Fecha"
                              format="dd/MM/yyyy"
                              value={actividadesEstados[actividad]?.fecha}
                              onChange={elegido => { handleChange(elegido, 'fecha'); setCampo('fechaLimite', elegido); }}
                              inputVariant="outlined"
                              className={clsx(classes.textField, classes.marginAuxT)}
                              InputProps={{
                                 margin: 'dense'
                              }}
                              KeyboardButtonProps={{
                                 'aria-label': 'elegir fecha'
                              }}
                              minDate={new Date()}
                           />
                        </Grid>
                        <Grid item xs={12} sm={6} lg={3} className={classes.alignContent}>
                           <KeyboardTimePicker
                              name="horaIni"
                              margin="normal"
                              id="time-picker"
                              label="Hora Atención"
                              value={actividadesEstados[actividad]?.horaIni}
                              onChange={elegido => handleChangeHoraAtencion(elegido)}
                              className={clsx(classes.textField, classes.marginAuxT)}
                              inputVariant="outlined"
                              InputProps={{
                                 margin: 'dense'
                              }}
                              KeyboardButtonProps={{
                                 'aria-label': 'elegir hora inicio'
                              }}
                           />
                        </Grid>
                        <Grid item xs={12} sm={12} lg={6} className={classes.alignContent}>
                           <SelectPlus
                              data={dataAsesorLibre}
                              label="Responsable de Actividad"
                              name="responsable"
                              value={actividadesEstados[actividad]?.responsable}
                              onChange={elegido => handleChange(elegido, 'responsable')}
                              genLabel={registro => {
                                 return `${registro.nombre} ${registro.apPaterno} ${registro.especialidad ? '(' + registro.especialidad + ')' : ''
                                    }`;
                              }}
                              variant="outlined"
                              InputLabelProps={{ shrink: true }}
                              className={clsx(classes.marginAuxT, classes.textField)}
                              error={actividadesEstados[actividad]?.responsable == null}
                              helperText={
                                 actividadesEstados[actividad]?.responsable == null
                                    ? 'Ingrese un responsable'
                                    : ''
                              }
                           />
                        </Grid>
                     </Grid>
                     <Grid container item xs={12} className={clsx(classes.marginAuxT)}>
                        <Grid item xs={6}>
                           <Button
                              variant="outlined"
                              color="primary"
                              onClick={() => { inicializar(); setMostrarActividades(false); }}
                           >
                              Cancelar
                           </Button>
                        </Grid>
                        <Grid container item xs={6} justify="flex-end">
                           <Button
                              onClick={verificarCruceHorario}
                              variant="contained"
                              color="primary"
                              startIcon={<SendIcon />}
                              disabled={existeError || disabled}
                           >
                              Programar
                           </Button>
                        </Grid>
                     </Grid>
                  </Grid>
               )}
            </Grid>
         </Paper>
         <DialogDs
            open={showMensaje}
            titulo={'Operación realizada correctamente.'}
            mostrarBotonesAccion={false}
            mensaje={`Su código de atención es: ${codigoEmail}`}
            onClose={handleClose}
         />
      </Container>
   );
}

function mapStateToProps(state) {
   return {
      usuario: state.auth.usuario
   };
}

function mapDispatchToProps(dispatch) {
   return {
      openMsgModal: msg => dispatch(openMsg(msg)),
      openWaitModal: loading => dispatch(loadingModal(loading))
   };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProgramarAtencion);
